export type RandomSpaceAccessPublicConfig = {
  enabled: boolean;
  candidates: string[];
  /** 是否显示粉色大按钮；关闭则为轻文字 */
  bigButton: boolean;
  /** 按钮文案；空则默认「为我推荐」 */
  buttonText: string;
};

export const DEFAULT_RANDOM_ENTER_BUTTON_TEXT = "为我推荐";

export function resolveRandomEnterButtonText(buttonText?: string | null): string {
  const t = (buttonText ?? "").trim();
  return t || DEFAULT_RANDOM_ENTER_BUTTON_TEXT;
}
